import { Grid } from '@mui/material';

import { DescriptionData } from '../../../../api/workOrders/types';
import {
  InputTitle,
  SmallStyledInput,
} from '../../../../components/UI/Typography';
import { Constants } from '../../../../constants/report';
import { GridContainer, ReportTitle } from './styles';

export interface ReadonlyComplementaryFieldsSectionProps {
  descriptionData: DescriptionData | undefined | null;
}

export function ReadonlyComplementaryFieldsSection({
  descriptionData,
}: ReadonlyComplementaryFieldsSectionProps): JSX.Element {
  return (
    <GridContainer container columnSpacing={2}>
      <Grid item xs={12}>
        <ReportTitle>{Constants.sumaryDiagnosis}</ReportTitle>
      </Grid>
      <Grid item xs={4}>
        <InputTitle>{Constants.performance}</InputTitle>
        <SmallStyledInput>
          {descriptionData?.dropdown.performance.chosen}
        </SmallStyledInput>
      </Grid>
      <Grid item xs={4}>
        <InputTitle>{Constants.offersNum}</InputTitle>
        <SmallStyledInput>
          {descriptionData?.dropdown.number_of_offers.chosen}
        </SmallStyledInput>
      </Grid>
      <Grid item xs={4}>
        <InputTitle>{Constants.offersNum}</InputTitle>
        <SmallStyledInput>
          {descriptionData?.dropdown.liquidity.chosen}
        </SmallStyledInput>
      </Grid>
      <Grid item xs={12}>
        <ReportTitle>
          {Constants.internal}
          <span style={{ textTransform: 'none' }}>{Constants.register}</span>
        </ReportTitle>
        <SmallStyledInput>
          {descriptionData?.internal_description}
        </SmallStyledInput>
      </Grid>
      <Grid item xs={12}>
        <ReportTitle>{Constants.preliminaries}</ReportTitle>
        <SmallStyledInput>{descriptionData?.preliminaries}</SmallStyledInput>
      </Grid>
      <Grid item xs={12}>
        <ReportTitle>{Constants.marketSearch}</ReportTitle>
        <SmallStyledInput>{descriptionData?.market_research}</SmallStyledInput>
      </Grid>
      <Grid item xs={12}>
        <ReportTitle>{Constants.diagnosis}</ReportTitle>
        <SmallStyledInput>{descriptionData?.market_diagnosis}</SmallStyledInput>
      </Grid>
      <Grid item xs={12}>
        <ReportTitle>{Constants.observations}</ReportTitle>
        <SmallStyledInput>{descriptionData?.observations}</SmallStyledInput>
      </Grid>
      <Grid item xs={12}>
        <ReportTitle>{Constants.docs}</ReportTitle>
        <SmallStyledInput>
          {descriptionData?.property_registry}
        </SmallStyledInput>
      </Grid>
      <Grid item xs={12}>
        <ReportTitle>{Constants.assumptions}</ReportTitle>
        <SmallStyledInput>
          {descriptionData?.assumptions_limiting_factors}
        </SmallStyledInput>
      </Grid>
    </GridContainer>
  );
}
